"use client";
/**
 * This is done because when packages get built the 'use client' directives are removed.
 * This caauses failures when a server component imports a component that relies on browser and DOM APIs
 * This wrapper can be removed once we change how we build the packages
 */
import { TrustPilotRatingWidget } from "@shared/ui.components";
import type { ExperimentFlags } from "@shared/utils.experimentation";
import { useEffect } from "react";
import { useExperimentViewed } from "tracking/hooks/useExperimentViewed";

type PropType = {
  experiment: {
    id: ExperimentFlags;
    value: string | number | boolean;
  };
};

export const TrustPilotRatingWidgetClientWrapper = ({
  experiment
}: PropType) => {
  const trackExperimentViewed = useExperimentViewed();
  useEffect(() => {
    trackExperimentViewed(experiment.id, Number(experiment.value));
  });

  return <TrustPilotRatingWidget />;
};
